import { Box, Checkbox, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocalStorage } from '../../../../hooks/providers/useLocalStorage';
import IConfirmationData from '../../../../interfaces/IConfirmationData';
import IWizardStep from '../../../../interfaces/IWizardStep';
import { ShowError, StyledAlert } from '../../components/ErrorMessage';
import WizardButton from '../../components/WizardButton';
import { WizardContent } from '../../components/WizardContent';
import { WizardTitle } from '../../components/WizardTitle';
import { StyledFormControlLabel } from './ConfirmationData.styled';
import moment from 'moment';

interface ConfirmationDataProps extends IWizardStep {}

const ConfirmationData = (props: ConfirmationDataProps) => {
  const [loading, setLoading] = useState(false);
  const [confirmationData, setConfirmationData] = useState<IConfirmationData | null>(null);
  const [confirmed, setConfirmed] = useState(props.medicalCertificate.confirmed);
  const localStorage = useLocalStorage();
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const confirmationData: IConfirmationData = localStorage.getItem('confirmationData');
    setConfirmationData(confirmationData);
  }, []);

  const handleSubmit = async () => {
    if (!confirmed) {
      setIsError(true);
      return;
    }
    setLoading(true);

    await props
      .setStep(props.step + 3, {
        ...props.medicalCertificate,
        confirmed: true,
        confirmedAt: moment().format('yyyy-MM-DD'),
      })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <WizardContent>
      <WizardTitle marginBotton={2}>Confirme seus dados:</WizardTitle>
      <Box sx={{ padding: '0px 20px 0px 20px' }}>
        <Box sx={{ marginTop: 2 }}>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Empresa
          </Typography>
          <Typography sx={{ fontSize: 17 }} component="div">
            {confirmationData?.companyName}
          </Typography>
        </Box>
        <Box sx={{ marginTop: 2 }}>
          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
            Colaborador
          </Typography>
          <Typography sx={{ fontSize: 17 }} component="div">
            {confirmationData?.employeeName}
          </Typography>
        </Box>
      </Box>

      <StyledFormControlLabel
        label={
          <Typography variant="body2">
            Sou responsável pela veracidade das informações fornecidas nesse site.
          </Typography>
        }
        control={
          <Checkbox
            onChange={e => {
              setIsError(false);
              setConfirmed(e.target.checked);
            }}
            checked={confirmed}
            sx={{
              color: 'rgb(32, 144, 136)',
              '&.Mui-checked': {
                color: 'rgb(32, 144, 136)',
              },
            }}
          />
        }
      />

      <div style={{ marginTop: '10px', marginBottom: '20px' }}>
        <ShowError show={isError}>
          <StyledAlert severity="error">Por fovor, confirme os dados para prosseguir.</StyledAlert>
        </ShowError>
      </div>
      <WizardButton isLoading={loading} disabled={loading} onClick={handleSubmit}>
        PRÓXIMO
      </WizardButton>
    </WizardContent>
  );
};

export default ConfirmationData;
